export default "__VITE_ASSET__93fde10a__"